<template>
    <section >
        <main class="my-2">
      
                <LoadingSpinner v-if="loading" />
                <div  v-if="!loading && result">
                
                    <div @click="openned = !openned" class="cursor-pointer">
                    
                    <span>{{result.lastModifiedDateTime}} </span>
                     <strong>  {{result.sender.emailAddress.name}} ({{result.sender.emailAddress.address}})</strong><br>
                     <strong :class="!saved ? 'text-danger':'text-success'">{{subject}} <i v-if="saved" class="icon-checkmark"></i><i v-else class="icon-close"></i></strong>
                    </div>

                    <div class="row mt-4 px-2 mx-2 mb-3"  v-if="openned">

                    {{result.lastModifiedDateTime}}

                      {{result.bodyPreview}}

                        
                          <p v-if="!saved" v-html="quoted_printable_decode(message)" class="email-body"></p>
                    </div>
                </div>
                <div v-else >
                    <span class="text-secondary">- Warmy -</span>
                </div>
        </main>
    </section>
</template>
<script>


import { mapState, mapActions } from "vuex";
import { router } from "@/_helpers";
import Header from "@/components/Header.vue";
import OpenAi from "@/components/OpenAi/OpenAi.vue";
import replyEmail from "@/components/Emails/replyEmail.vue";
import { statusBadgeMixin, linksMixin } from "@/_mixins/";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { emailsService, monitorService, businessesService, opportunitiesService, campaignsService, businessContactsService } from "@/_services";
import  ActionButtons  from "@/components/Emails/ActionButtons.vue";
const sleep = d => new Promise(r => setTimeout(r, d));


export default {
     data() {
        return {
            message:false,
            subject: '',
            saved: false,
            result:'',
            openned: false,
        }
    },
    props: {
        selectedEmailId: String,
        email: String
    },

    mixins: [statusBadgeMixin, linksMixin],

    components: {
        Header,
        replyEmail,
        ActionButtons,
        LoadingSpinner,  
        OpenAi,
     },

  computed: {
    ...mapState({
        loading: state => state.emails.loading,
        selected: state => state.emails.selected.data,
        currentUser: state => state.authentication.user
    }),  
    ...mapState({
        headerTab: state => state.header.tab
    })},
    

    user() {
      return this.$store.state.authentication.user;
    },

    created() {
        this.getEmail();
    },
    
    methods: {
        quoted_printable_decode (str) { // eslint-disable-line camelcase
        

         if(str && str.indexOf('=E9') && !str.indexOf('http'))  {


         var RFC2045Decode1 = /=\r\n/gm
          // the RFC states against decoding lower case encodings, but following apparent PHP behavior
          var RFC2045Decode2IN = /=([0-9A-F]{2})/gim
          var RFC2045Decode2OUT = function (sMatch, sHex) {
            return String.fromCharCode(parseInt(sHex, 16))
          }

          return str.replace(RFC2045Decode1, '')
            .replace(RFC2045Decode2IN, RFC2045Decode2OUT)

         }
        
        return str;



        },    
        ...mapActions("header", {
            changeHeaderTab: "changeTab"
        }),
        removeTagsHTML(texto) {
          let div = document.createElement("div");
          div.innerHTML = texto;
          return div.textContent || div.innerText || "";
        },
        quoted_printable_decode (str) { // eslint-disable-line camelcase
        

         if(str && str.indexOf('=E9') && !str.indexOf('http'))  {


         var RFC2045Decode1 = /=\r\n/gm
          // the RFC states against decoding lower case encodings, but following apparent PHP behavior
          var RFC2045Decode2IN = /=([0-9A-F]{2})/gim
          var RFC2045Decode2OUT = function (sMatch, sHex) {
            return String.fromCharCode(parseInt(sHex, 16))
          }

          return str.replace(RFC2045Decode1, '')
            .replace(RFC2045Decode2IN, RFC2045Decode2OUT)

         }
        
        return str;

        },    
        getEmail() {

            emailsService.getAPIEmail( this.selectedEmailId, this.email  ).then((result) => {
                this.subject = result.subject
                this.message = result.message
                this.saved = result.saved
                this.result = result.result
            })

        },
    }

}

</script>
<style>
.email-body {
    white-space: pre-wrap;
}

.email-body * {
    white-space: initial;
}
.md-chip{
    height: 32px;
    padding: 0 12px;
    display: inline-block;
    cursor: default;
    border-radius: 32px;
    transition: .3s cubic-bezier(.25,.8,.25,1);
    transition-property: background-color,color,opacity,transform,box-shadow;
    will-change: background-color,color,opacity,transform,box-shadow;
    font-size: 13px;
    line-height: 32px;
    vertical-align: middle;
    white-space: nowrap;
    cursor: pointer;
}
.md-default{
    background-color:rgb(162, 158, 158);
    color:white;
}
.content-search-opp{
    position: relative;
}
.list-result-opp{
    position: absolute;
    background-color: white;
    top: 5px;
    width: 100%;
}
.list-result-opp li{
    padding: 5px;
    font-size: 13px;
    font-weight: 600;
}
.list-result-opp li:hover{
    background-color:rgb(217, 212, 212);
    cursor: pointer;
    
}
.list-result-opp li:first-child{
    padding-top: 0;
    padding-bottom: 0;
    font-size: 14px;
    max-height: 8px;
}
.list-result-opp li:first-child:hover{
    background-color: transparent;
}
.c-pointer{
    cursor: pointer;
}
.divider{
    background-color: rgba(0,0,0,.12);
    margin-top: -1px;
    height: 1px;
    margin: 0;
    padding: 0;
    display: block;
    border: 0;
    transition: margin-left .3s cubic-bezier(.4,0,.2,1);
    will-change: margin-left;
}
.list{
    padding: 1.2em !important;
}

.content-search-opp .loading-spinner {
    width: 3rem;
    height: 3rem;
}

.content-search-opp .spinner-container {
    height: auto;
}

</style>